import './pagination-block.scss';

export default () => {

};
